(() => {
  const stripInternalCode = (value) => {
    let cleaned = String(value || '').trim().replace(/\s*(?:\||｜|·)\s*(?:HC|CS|ES)-[A-Z0-9-]+\s*$/i, '');
    cleaned = cleaned.replace(/\b(?:HC|CS|ES)\s+(?=傳承典藏系列|精選收藏系列|入門收藏系列)/gi, '');
    return cleaned.trim();
  };

  const sectionId = (section) => {
    if (section.classList.contains('pdp-v3__making')) return 'ts-making';
    if (section.classList.contains('pdp-v3__care')) return 'ts-care';
    if (section.classList.contains('pdp-v3__figure')) return 'ts-figure';
    if (section.classList.contains('pdp-v3__story')) return 'ts-story';
    if (section.classList.contains('pdp-v3__culture')) return 'ts-culture';
    if (section.classList.contains('pdp-v3__object')) return 'ts-object';
    return '';
  };

  const cleanVisibleTitle = (scope) => {
    scope.querySelectorAll('[data-testid="product-information-details"] h1, .sticky-add-to-cart__title, .resource-card__title, .resource-card__link .visually-hidden').forEach((title) => {
      if (title.dataset.tsTitleCleaned === 'true') return;
      const cleaned = stripInternalCode(title.textContent);
      if (cleaned) title.textContent = cleaned;
      title.dataset.tsTitleCleaned = 'true';
    });
  };

  const buildQuickDetails = (scope) => {
    const section = scope.querySelector('.product-information .pdp-v3__details');
    if (!section || section.dataset.tsRefined === 'true') return;
    const isZh = Boolean(section.closest('.pdp-v3--zh'));
    const details = document.createElement('details');
    details.className = 'pdp-v3__quick-details';
    details.id = 'ts-details';
    details.open = true;
    const summary = document.createElement('summary');
    summary.innerHTML = `<span>${isZh ? '作品資料' : 'Object details'}</span><span aria-hidden="true">+</span>`;
    const panel = document.createElement('div');
    panel.className = 'pdp-v3__quick-details-panel';
    const head = section.querySelector(':scope > .pdp-v3__section-head');
    [...section.children].forEach((child) => {
      if (child !== head) panel.appendChild(child);
    });
    details.append(summary, panel);
    details.dataset.tsRefined = 'true';
    section.replaceWith(details);
  };

  const buildLongformAccordions = (scope) => {
    scope.querySelectorAll('.ts-pdp-longform-section .pdp-v3__section:not(.pdp-v3__details)').forEach((section) => {
      if (section.dataset.tsRefined === 'true') return;
      const head = section.querySelector(':scope > .pdp-v3__section-head');
      const tag = head?.querySelector('.pdp-v3__tag')?.textContent?.trim() || '';
      const heading = stripInternalCode(head?.querySelector('h2')?.textContent || '');
      const details = document.createElement('details');
      details.className = `pdp-v3__accordion ${[...section.classList].filter((name) => name.startsWith('pdp-v3__') && name !== 'pdp-v3__section').join(' ')}`;
      const id = sectionId(section);
      if (id) details.id = id;
      const summary = document.createElement('summary');
      summary.innerHTML = `<span class="pdp-v3__accordion-heading"><small>${tag}</small><strong>${heading}</strong></span><span class="pdp-v3__accordion-mark" aria-hidden="true">+</span>`;
      const panel = document.createElement('div');
      panel.className = 'pdp-v3__accordion-panel';
      if (head) {
        [...head.children].forEach((child) => {
          if (!child.matches('.pdp-v3__tag, h2')) panel.appendChild(child);
        });
      }
      [...section.children].forEach((child) => {
        if (child !== head) panel.appendChild(child);
      });
      details.append(summary, panel);
      details.dataset.tsRefined = 'true';
      section.replaceWith(details);
    });
  };

  const bindTrustAnchors = (scope) => {
    scope.querySelectorAll('.ts-pdp-trust a[href^="#ts-"]').forEach((link) => {
      if (link.dataset.tsBound === 'true') return;
      link.addEventListener('click', () => {
        const target = document.querySelector(link.getAttribute('href'));
        if (target?.tagName === 'DETAILS') target.open = true;
      });
      link.dataset.tsBound = 'true';
    });
  };

  const refine = (scope = document) => {
    cleanVisibleTitle(scope);
    buildQuickDetails(scope);
    buildLongformAccordions(scope);
    bindTrustAnchors(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refine());
  } else {
    refine();
  }
  document.addEventListener('shopify:section:load', (event) => refine(event.target));
  let queued;
  new MutationObserver(() => {
    window.clearTimeout(queued);
    queued = window.setTimeout(() => cleanVisibleTitle(document), 40);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
